export const Config = () => ({
  myUpdates: import.meta.env.VITE_APP_UPDATES_CONFIG === 'FALSE',
});

export const disableMyUpdates = () => {
  return Config().myUpdates;
};

export const shorterDateFormat = 'd.M.yy';
export const shortDateFormat = 'd.M.yyyy';
export const dotDateFormat = 'd.M.yyyy';
export const slashDateFormat = 'dd/MM/yyyy';
export const dotDateFormatMM = 'dd.MM.yyyy';
export const syphonDateFormat = 'dd-MM-yyyy';
export const mmddyyyyFormat = 'MM-dd-yyyy';
export const dateAndTimeFormat = 'dd/MM/yyyy HH:mm';
export const timeFormat = 'HH:mm';
export const dateAndTimeFormatWithText = 'dd.MM.yyyy בשעה HH:mm';
export const dateAndTimeFormatWithPipe = 'dd.MM.yyyy | HH:mm';
export const shortDateAndTimeFormatWithPipe = 'dd.MM.yy | HH:mm';
export const monthYearFormat = 'LLLL yyyy';

export const autocompleteShowResultInputLimit = 1;

export const mokedNumber = '8150*';

export const MAX_FILE_SIZE_IN_MB = 20;
export const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * 1024 * 1024;
export const MAX_TREATMENT_TYPE = 20;
export const MAX_NOTE_LENGTH = 500;
export const MAX_DEPARTMENT_INITIATED_USER_NOTE_LENGTH = 450;
export const ALLOWED_FILE_TYPES = '.doc,.docx,.jpg,.jpeg,.png,.pdf,.tif,.tiff';
export const ALLOWED_EXCEL_CSV_FILE_TYPES = '.csv,.xlsx';
export const DELETE_TOAST_DURATION_MS = 6000; // 6 seconds
export const IRON_SWORDS_FORM_ID = 300;

export const PERSONAL_RECOMMENDATION_URLS: { [key: number]: string } = {
  200: `/requests/update-personal-details/8/200`,
  201: `/requests/update-bank-details/8/201`,
  202: `/requests/expense-claim/3/202`,
  203: `/requests/expense-claim/3/203`,
  204: `/requests/expense-claim/3/204`,
  205: `/requests/expense-claim/3/205`,
  206: `/requests/expense-claim/3/206`,
  207: `/requests/expense-claim/3/207`,
};

export const DISABLED_VETERAN_SUB_ID = 23;

export const EquipmentPageSize = 10;
export const ALLOWED_VIDEO_TYPES = '.webm,.mp4,.mov';

export const AUDIO_VIDEO_EXTENSIONS = [
  'mp4',
  'wav',
  'mp3',
  'ogg',
  'webm',
  'mov',
] as const;

export const DEFAULT_AUTOCOMPLETE_RESULT_LIMIT = 10;
export const DEFAULT_MAX_AUTOCOMPLETE_RESULT_LIMIT = 100;

export const defaultMinDate = new Date('1/1/1900');
export const alternativeMedicineMaxDate = new Date('2026-12-31');
export const futureDateError = 'לא ניתן להגיש החזר על טיפול עתידי';
export const pastDateError = 'תאריך לא חוקי';

export const MAX_PERMANENT_DATE_YEAR = 2999;

export const burgerMenuItemsPersonalDetailsAndUpdatesSlicer = 2;

export const flyingCarpetRedirectCode = 1;
export const eshetTursRedirectCode = 2;

export const activityGuardTimerTimeout = 2100;
export const activityGuardTimerAlert = 300;
export const activityGuardTimerAlertTimeoutMs = 300000;

export const maxPhoneDigits = 7;

export const MALE_ID = 1;
export const FEMALE_ID = 2;

export const maxPriceDigits = 6;
export const maxPriceDecimalDigits = 2;

export * from './routes';

export * from './committeeSteps';

export const IsrIdLength = 9;

export const maxAnalysisResults = 15000;

export const searchResultsRelevanceViewers = [
  '999410772',
  '036498079',
  '999573322',
  '308118801',
  '200738433',
  '310290945',
];
